import { Injectable, TemplateRef } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

import { MESSAGE_TYPE } from '@constants/message-type';
import { Toast } from '@models/toast/toast';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class NotificationService {
  toasts: Toast[] = [];

  private subject = new Subject();
  designPreviewObservable = this.subject.asObservable();

  private MESSAGE_DEFAULT_DISPLAY_DURATION = 5000;
  private MESSAGE_EXPANDED_DISPLAY_DURATION = 10000;

  constructor(private translate: TranslateService) {
  }

  show(textOrTpl: string | TemplateRef<any>, header: string | TemplateRef<any>, options: any = {}) {
    this.toasts.push({textOrTpl, header, ...options});
  }

  remove(toast: Toast) {
    this.toasts = this.toasts.filter(t => t !== toast);
  }

  regular(message: string, page: string, persist: boolean, title?: string) {
    const finalTitle = this.getMessageTitle(MESSAGE_TYPE.REGULAR, title);
    const displayDuration = this.getDisplayDuration(persist);
    console.log(page + '. ' + message);
    this.show(message, finalTitle, {delay: displayDuration});
  }

  success(message: string, page: string, persist: boolean, title?: string) {
    const finalTitle = this.getMessageTitle(MESSAGE_TYPE.SUCCESS, title);
    const displayDuration = this.getDisplayDuration(persist);
    console.log(page + '. ' + message);
    this.show(message, finalTitle, {classname: 'bg-success text-light', delay: displayDuration});
  }

  warning(message: string, page: string, title?: string, autohide: boolean = true) {
    const finalTitle = this.getMessageTitle(MESSAGE_TYPE.WARNING, title);
    console.warn(page + '. ' + message);
    this.show(message, finalTitle, {classname: 'bg-warning text-light', autohide: autohide});
  }

  error(message: string, error: object | null, page: string, persist: boolean, title?: string, autohide: boolean = true) {
    const finalTitle = this.getMessageTitle(MESSAGE_TYPE.ERROR, title);
    const displayDuration = this.getDisplayDuration(persist);
    if (error !== null) {
      console.error(page + '. ' + message, JSON.stringify(error));
    } else {
      console.error(page + '. ' + message);
    }
    this.show(message, finalTitle, {
      classname: 'bg-danger text-light',
      delay: displayDuration,
      autohide: autohide,
    });
  }

  designPreviewSubject() {
    this.subject.next(null);
  }


  private getMessageTitle(type: string, title?: string) {
    let finalTitle: string = '';
    if (typeof title === 'undefined' || title.length === 0 || title.trim().length === 0) {
      switch (type) {
        case MESSAGE_TYPE.ERROR: {
          finalTitle = this.translate.instant('Error');
          break;
        }
        case MESSAGE_TYPE.WARNING: {
          finalTitle = this.translate.instant('Warning');
          break;
        }
        case MESSAGE_TYPE.SUCCESS: {
          finalTitle = this.translate.instant('Success');
          break;
        }
        case MESSAGE_TYPE.REGULAR: {
          finalTitle = this.translate.instant('Info');
          break;
        }
      }
    } else {
      finalTitle = title;
    }
    return finalTitle;
  }

  private getDisplayDuration(shouldPersist: boolean) {
    let displayDuration = this.MESSAGE_DEFAULT_DISPLAY_DURATION;
    if (shouldPersist) {
      displayDuration = this.MESSAGE_EXPANDED_DISPLAY_DURATION;
    }
    return displayDuration;
  }
}
